import { CircularProgress } from '@mui/material'
import React from 'react'

const Spinner = () => {
  return (
    <CircularProgress color="inherit" />
  )
}

export default Spinner